const provinces = [
  { jw_code: '10', jw_name: 'กรุงเทพมหานคร' },
  { jw_code: '11', jw_name: 'สมุทรปราการ' },
  { jw_code: '12', jw_name: 'นนทบุรี' },
  { jw_code: '13', jw_name: 'ปทุมธานี' },
  { jw_code: '14', jw_name: 'พระนครศรีอยุธยา' },
  { jw_code: '15', jw_name: 'อ่างทอง' },
  { jw_code: '16', jw_name: 'ลพบุรี' },
  { jw_code: '17', jw_name: 'สิงห์บุรี' },
  { jw_code: '18', jw_name: 'ชัยนาท' },
  { jw_code: '19', jw_name: 'สระบุรี' },
  { jw_code: '20', jw_name: 'ชลบุรี' },
  { jw_code: '21', jw_name: 'ระยอง' },
  { jw_code: '22', jw_name: 'จันทบุรี' },
  { jw_code: '23', jw_name: 'ตราด' },
  { jw_code: '24', jw_name: 'ฉะเชิงเทรา' },
  { jw_code: '25', jw_name: 'ปราจีนบุรี' },
  { jw_code: '26', jw_name: 'นครนายก' },
  { jw_code: '27', jw_name: 'สระแก้ว' },
  { jw_code: '30', jw_name: 'นครราชสีมา' },
  { jw_code: '31', jw_name: 'บุรีรัมย์' },
  { jw_code: '32', jw_name: 'สุรินทร์' },
  { jw_code: '33', jw_name: 'ศรีสะเกษ' },
  { jw_code: '34', jw_name: 'อุบลราชธานี' },
  { jw_code: '35', jw_name: 'ยโสธร' },
  { jw_code: '36', jw_name: 'ชัยภูมิ' },
  { jw_code: '37', jw_name: 'อำนาจเจริญ' },
  { jw_code: '38', jw_name: 'บึงกาฬ' },
  { jw_code: '39', jw_name: 'หนองบัวลำภู' },
  { jw_code: '40', jw_name: 'ขอนแก่น' },
  { jw_code: '41', jw_name: 'อุดรธานี' },
  { jw_code: '42', jw_name: 'เลย' },
  { jw_code: '43', jw_name: 'หนองคาย' },
  { jw_code: '44', jw_name: 'มหาสารคาม' },
  { jw_code: '45', jw_name: 'ร้อยเอ็ด' },
  { jw_code: '46', jw_name: 'กาฬสินธุ์' },
  { jw_code: '47', jw_name: 'สกลนคร' },
  { jw_code: '48', jw_name: 'นครพนม' },
  { jw_code: '49', jw_name: 'มุกดาหาร' },
  { jw_code: '50', jw_name: 'เชียงใหม่' },
  { jw_code: '51', jw_name: 'ลำพูน' },
  { jw_code: '52', jw_name: 'ลำปาง' },
  { jw_code: '53', jw_name: 'อุตรดิตถ์' },
  { jw_code: '54', jw_name: 'แพร่' },
  { jw_code: '55', jw_name: 'น่าน' },
  { jw_code: '56', jw_name: 'พะเยา' },
  { jw_code: '57', jw_name: 'เชียงราย' },
  { jw_code: '58', jw_name: 'แม่ฮ่องสอน' },
  { jw_code: '60', jw_name: 'นครสวรรค์' },
  { jw_code: '61', jw_name: 'อุทัยธานี' },
  { jw_code: '62', jw_name: 'กำแพงเพชร' },
  { jw_code: '63', jw_name: 'ตาก' },
  { jw_code: '64', jw_name: 'สุโขทัย' },
  { jw_code: '65', jw_name: 'พิษณุโลก' },
  { jw_code: '66', jw_name: 'พิจิตร' },
  { jw_code: '67', jw_name: 'เพชรบูรณ์' },
  { jw_code: '70', jw_name: 'ราชบุรี' },
  { jw_code: '71', jw_name: 'กาญจนบุรี' },
  { jw_code: '72', jw_name: 'สุพรรณบุรี' },
  { jw_code: '73', jw_name: 'นครปฐม' },
  { jw_code: '74', jw_name: 'สมุทรสาคร' },
  { jw_code: '75', jw_name: 'สมุทรสงคราม' },
  { jw_code: '76', jw_name: 'เพชรบุรี' },
  { jw_code: '77', jw_name: 'ประจวบคีรีขันธ์' },
  { jw_code: '80', jw_name: 'นครศรีธรรมราช' },
  { jw_code: '81', jw_name: 'กระบี่' },
  { jw_code: '82', jw_name: 'พังงา' },
  { jw_code: '83', jw_name: 'ภูเก็ต' },
  { jw_code: '84', jw_name: 'สุราษฎร์ธานี' },
  { jw_code: '85', jw_name: 'ระนอง' },
  { jw_code: '86', jw_name: 'ชุมพร' },
  { jw_code: '90', jw_name: 'สงขลา' },
  { jw_code: '91', jw_name: 'สตูล' },
  { jw_code: '92', jw_name: 'ตรัง' },
  { jw_code: '93', jw_name: 'พัทลุง' },
  { jw_code: '94', jw_name: 'ปัตตานี' },
  { jw_code: '95', jw_name: 'ยะลา' },
  { jw_code: '96', jw_name: 'นราธิวาส' }
];
export default provinces;
